<template>
  <div class="guided-mode-symptoms__selected">
    <p :id="headingId" ref="heading" class="guided-mode-symptoms__selected-title" tabindex="-1">
      {{ $t('app.assessment_mode.guided.symptoms.selected') }}
    </p>
    <ul v-if="items.length" class="guided-mode-symptom-chips" :aria-labelledby="headingId">
      <li v-for="(item, index) in items" :key="item.id" class="guided-mode-symptom-chip">
        <span class="guided-mode-symptom-chip__label">{{ item.label }}</span>
        <button
          ref="removeButtons"
          type="button"
          class="guided-mode-symptom-chip__remove"
          data-analytics-skip
          :aria-label="$t('app.assessment_mode.guided.symptoms.remove', { symptom: item.label })"
          @click="remove(index)"
        >
          <v-icon class="guided-mode-symptom-chip__icon" size="18">{{ mdiClose }}</v-icon>
        </button>
      </li>
    </ul>
  </div>
</template>

<script lang="ts">
import { defineComponent, PropType } from 'vue'
import { mdiClose } from '@mdi/js'
import type { GuidedModeSymptomChip } from '../utils/symptoms'

export default defineComponent({
  name: 'GuidedModeSymptomChips',
  props: {
    items: { type: Array as PropType<GuidedModeSymptomChip[]>, default: () => [] },
    headingId: { type: String, required: true },
  },
  emits: ['remove'],
  data: () => ({ mdiClose }),
  methods: {
    remove(index: number) {
      this.$emit('remove', this.items[index].id)
      this.$nextTick(() => {
        const buttons = (this.$refs.removeButtons || []) as HTMLButtonElement[]
        const next = buttons[index] || buttons[index - 1] || this.$refs.heading as HTMLElement
        next.focus()
      })
    },
  },
})
</script>
